// TODO ak by trebalo key!=value, vstupne options treba zmenit z listu na objekt
(mapu)

<template>
  <div class="field">
    <label class="label" v-if="label">{{ label }}</label>
    <div class="control">
      <div class="select">
        <select
          @change.prevent="onChange"
          :value="value"
          :class="{ 'is-danger': errors && errors.length > 0 }"
          @focus="onFocus"
          :disabled="disabled"
        >
          <option v-for="option in options" :key="option" :value="option">
            {{ $t(option) }}
          </option>
        </select>
      </div>
    </div>
    <p class="help is-danger" v-if="errors && errors[0]">
      {{ $t(errors && errors[0]) }}
    </p>
  </div>
</template>

<script>
export default {
  name: "select-field",
  props: ["value", "options", "label", "errors", "disabled"],
  methods: {
    onChange(e) {
      this.$emit("change", e.target.value)
      this.$emit("input", e.target.value)
    },
    onFocus(e) {
      this.$emit("focus", e.target.value)
    }
  }
}
</script>
